import AbstractCustomFieldsSettingsPageController from './abstract-custom-fields';

export default class GuestlistCustomFieldsSettingsPageController extends AbstractCustomFieldsSettingsPageController {

    _getHeadline() {
        return 'Guestlist custom fields';
    }

    _getCustomFieldCount() {
        return 30;
    }

    _getCustomFieldSuffix() {
        return '_guestlist';
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/settings/controllers/custom-fields/guestlist-custom-fields.js